import Vue from 'vue';
import axios from 'axios';
import VueI18n from 'vue-i18n';

// include reset and utility classes
import '@/base/global-css/_classes.scss';

// polyfills for IE11
import '@/base/global-js/Polyfills';

// js utilities that need direct access to the DOM
import '@/base/global-js/AnalyticsEvents';
import '@/base/global-js/GoToTop';
//import '@/base/global-js/InputType';
import '@/base/global-js/LanguageSwitcher';
import '@/base/global-js/LazyLoader';
import '@/base/global-js/LinkMimic';
import '@/base/global-js/ResizeListener';
import '@/base/global-js/Tooltip';
import '@/base/global-js/TogglePanel';
import '@/base/global-js/Utilities';

// Handle translations from global langMap varible
Vue.use(VueI18n);
// here we use a string "locale", but could be anything, such as "foo"
// the app will populate langMap with the requested language
// so VueI18n doesn't need to worry about the locale code
const i18n = new VueI18n({
	locale: 'locale',
	fallbackLocale: 'locale',
	messages: {
		locale: window.langMap,
	},
});

// when page loads, send our own loaded event
window.addEventListener('DOMContentLoaded', function () {
	// send event to initialize non-Vue functionality
	document.dispatchEvent(new CustomEvent('lichen:loaded'));
});
